import { autoinject, Aurelia } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { activationStrategy, Redirect } from 'aurelia-router';
import { RouterConfiguration } from "aurelia-router";
import { PageMessageService } from "../services/page-message-service";
import { BusyService } from "../services/busy-service";
import { Router } from 'aurelia-router';
import { routes } from './routes';
import { SignalrService } from '../services/signalr-service';
import { SecurityService } from '../services/security-service';
import "../resources/validation-rules";
import * as AppRouterOverride from '../au-overrides/app-router';
import { SecurityRole } from '../resources/attributes/security-role';

@autoinject
export class App {
    environment: any;

    constructor(
        private aurelia: Aurelia,
        private route: Router,
        public busyService: BusyService,
        public securityService: SecurityService,
        private pageMessageService: PageMessageService,
        private ea: EventAggregator,
        private signalr: SignalrService) {
        (<any>this.aurelia).subscribe('router:navigation:complete', msg => this.onNavigationComplete(msg));

        this.environment = (<any>aurelia.host.attributes).environment.value.toLowerCase();

        signalr.init();
    }

    configureRouter(config, router) {
        config.title = 'Carrier Management Portal';
        config.options.pushState = true;

        let root = '/'
        if (this.environment == 'development') {
            root = '/auth0/';
        }
        config.options.root = root + 'secure';
        config.addPipelineStep('authorize', AuthorizeStep);
        config.map(routes);
        this.supportMiddleClickInLinks(config);

        /**
         * Override the original AppRouter.generate function by removing leading "/"
         * See https://github.com/aurelia/templating-router/issues/57
         */
        AppRouterOverride.apply();

    }



    // temporary fix for https://github.com/aurelia/router/issues/457
    supportMiddleClickInLinks(config: RouterConfiguration) {
        let $ = window["$"];
        const addBaseUrlIfMiddleClick = (event: JQueryEventObject) => {
            if (event.ctrlKey || event.which == 2) {
                const link = $(event.currentTarget);
                const originalHref = link.attr('href');
                link.attr('href', config.options.root + '/' + originalHref);
                setTimeout(() => link.attr('href', originalHref));
            }
        };
        $(document).arrive("a[route-href]", function (newLink) {
            $(newLink).mouseup(addBaseUrlIfMiddleClick);
        });
    }



    onNavigationComplete(msg) {
        if (!msg.result.completed) {
            return;
        }

        window.scrollTo(0, 0);
    }

}

class AuthorizeStep {
    static inject() { return [SecurityService]; }

    securityService: SecurityService;
    constructor(securityService) {
        this.securityService = securityService;
    }

    run(routingContext, next) {
        return this.securityService.init()
            .then(() => {
                //if no role defined on the route, then allow it, otherwise check to ensure current user has the specified role.
                if (!routingContext.config.role || this.securityService.hasRole(routingContext.config.role)) {

                    // if targeting the "landing" route, then redirect according to user role
                    if (routingContext.config.name == "landing") {
                        // if user has "edit" role, then go to tasks
                        if (this.securityService.hasRole("Edit")) {
                            return next.cancel(new Redirect('tasks'));
                        } else {
                            // otherwise go to dashboard
                            return next.cancel(new Redirect('dashboard'));
                        }
                    } else {
                        return next();
                    }
                } else {
                    return next.cancel(new Redirect('access-denied'));
                }
            });
    }
}